export function downloadCSV(content, filename = 'data.csv') {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}

/**
 * @param {Array<Object>} data - Array of row objects
 * @param {Array<{ key: string, header: string }>} columns - Column mapping
 * @returns {string} CSV string with header row and data rows
 */
export function convertToCSV(data, columns) {
    const escapeValue = (val) => {
        if (val === null || val === undefined) return '';
        const str = String(val);
        if (str === '') return '';
        if (
            str.includes(',') ||
            str.includes('"') ||
            str.includes('\n') ||
            str.includes('\r')
        ) {
            return '"' + str.replace(/"/g, '""') + '"';
        }
        return str;
    };

    const headerRow = columns.map((col) => escapeValue(col.header)).join(',');
    const dataRows = data.map((row) =>
        columns.map((col) => escapeValue(row[col.key])).join(',')
    );

    return [headerRow, ...dataRows].join('\n');
}
